// ===== ANONYMOUS AI v25.0 QUANTUM - MEMORY HOOK =====

import { useState, useEffect, useCallback } from 'react';
import memoryService from '../services/memoryService';

export const useMemory = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [stats, setStats] = useState(null);

  // Load conversation from memory
  const loadConversation = useCallback(async () => {
    setIsLoading(true);
    try {
      const messages = await memoryService.loadConversation();
      return messages;
    } catch (error) {
      console.error('Failed to load conversation:', error);
      return [];
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Save conversation to memory
  const saveConversation = useCallback(async (messages) => {
    try {
      await memoryService.saveConversation(messages);
    } catch (error) {
      console.error('Failed to save conversation:', error);
    }
  }, []);

  // Clear current conversation
  const clearConversation = useCallback(async () => {
    try {
      await memoryService.clearConversation();
    } catch (error) {
      console.error('Failed to clear conversation:', error);
    }
  }, []);

  // Get conversation history
  const getHistory = useCallback(async () => {
    try {
      return await memoryService.getHistory();
    } catch (error) {
      console.error('Failed to get history:', error);
      return [];
    }
  }, []);

  // Load stats
  const loadStats = useCallback(async () => {
    try {
      const newStats = await memoryService.getStats();
      setStats(newStats);
    } catch (error) {
      console.error('Failed to load stats:', error);
    }
  }, []);

  // Auto-save effect
  useEffect(() => {
    loadStats();
  }, [loadStats]);

  return {
    loadConversation,
    saveConversation,
    clearConversation,
    getHistory,
    stats,
    isLoading
  };
};
